<script context="module">

  export function preprocess(excercise_content, replace_tokens) {
    let task = [], assignments = [];

    let html = new DOMParser().parseFromString(excercise_content, "text/html");
    let children = [ ...(html['body'].children) ]; // spread operator converts to array
    let separatorIndex = children.findIndex(el => el.innerHTML == "&nbsp;");

    children.forEach( (el, i) => {
      if (i < separatorIndex)
        task.push(el);
      if (i > separatorIndex)
        assignments.push(el);
    })

    const regex = /\[\[(.*)\]\]\s?/i;
    assignments.forEach(el => {
      el.correctAnswer = el.innerHTML.match(regex)[1] // take first sub-group
      el.innerHTML = el.innerHTML.replace(regex, replace_tokens);
    })

    return [task, assignments];
  }

  export function check(assignments) {
    assignments.forEach(el => {
      el.correctness = el.correctAnswer == el.givenAnswer
    });
    return assignments.every(el => el.correctness);
  }

  export function save(mod, step, assignments) {
    let answers = assignments.map( el => {
      return {
        correct: el.correctAnswer,
        given: el.givenAnswer
      }
    })

    if (mod.exercises === undefined)
      mod.exercises = {};

    mod.exercises[step.title] = answers;
  }

</script>

<script>
  import { _ } from 'svelte-i18n';

  export let course;
  export let mod;
  export let step;
</script>

<div class="alert alert-error shadow-lg w-96 mt-16">
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" class="stroke-current flex-shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
    <span>
      {@html $_('course.bad_step', { values: { course: course.name, module: mod.name, step: step.title } })}
    </span>
  </div>
</div>